import request from '@/utils/request'

// Get VIP packages
export function getVipPackages(params) {
  return request({
    url: '/api/admin/Vip/packages',
    method: 'get',
    params: {
      activeOnly: params?.activeOnly || false
    }
  })
}

// Create VIP package
export function createVipPackage(data) {
  return request({
    url: '/api/admin/Vip/packages',
    method: 'post',
    data
  })
}

// Purchase VIP package
export function purchaseVipPackage(data) {
  return request({
    url: '/api/Vip/purchase',
    method: 'post',
    data
  })
}

// Get customer VIP packages
export function getCustomerVipPackages(customerId, params) {
  return request({
    url: `/api/admin/Vip/customer/${customerId}/purchases`,
    method: 'get',
    params: {
      activeOnly: params?.activeOnly || false
    }
  })
}

// Check customer VIP state (returns VIP level/type as string)
export function checkCustomerVipState(customerId, activeOnly = false) {
  return request({
    url: `/api/admin/Vip/customer/${customerId}/purchases`,
    method: 'get',
    params: { activeOnly }
  })
}

// Update VIP package
export function updateVipPackage(id, data) {
  return request({
    url: `/api/admin/Vip/packages/${id}`,
    method: 'put',
    data: {
      ...data,
      packageId: parseInt(id)
    }
  })
}

// Toggle VIP package active/inactive (soft delete)
export function toggleVipPackageActive(id) {
  return request({
    url: `/api/admin/Vip/packages/${id}/toggle-active`,
    method: 'patch'
  })
}

// Get customer VIP purchase history
export function getCustomerVipPurchases(customerId) {
  return request({
    url: `/api/admin/Vip/customer/${customerId}/purchases`,
    method: 'get'
  })
}

// Get customer VIP consumption history
export function getCustomerVipConsumptionHistory(customerId) {
  return request({
    url: `/api/admin/Vip/customer/${customerId}/consumption-history`,
    method: 'get'
  })
}

// Get VIP income statistics
export function getVipIncomeStatistics(params) {
  const queryParams = {}
  
  // Date range parameters
  if (params?.startDate) {
    queryParams.startDate = params.startDate
  }
  if (params?.endDate) {
    queryParams.endDate = params.endDate
  }
  
  // Filter parameters
  if (params?.customerId !== undefined && params?.customerId !== null) {
    queryParams.customerId = params.customerId
  }
  if (params?.packageTypeId !== undefined && params?.packageTypeId !== null) {
    queryParams.packageTypeId = params.packageTypeId
  }
  if (params?.vipPackageId !== undefined && params?.vipPackageId !== null) {
    queryParams.vipPackageId = params.vipPackageId
  }
  
  // Pagination parameters
  if (params?.pageIndex !== undefined && params?.pageIndex !== null) {
    queryParams.pageIndex = params.pageIndex
  }
  if (params?.pageSize !== undefined && params?.pageSize !== null) {
    queryParams.pageSize = params.pageSize
  }
  
  return request({
    url: '/api/admin/Vip/statistics',
    method: 'get',
    params: queryParams
  })
}

// Admin purchase VIP with payment (WeChat Pay)
export function adminPurchaseWithPayment(data) {
  return request({
    url: '/api/admin/Vip/admin/purchase-with-pay',
    method: 'post',
    data
  })
}

// Admin purchase VIP without payment (Operation Mode 1 - Yearly Fee)
export function adminPurchaseNoPayment(data) {
  return request({
    url: '/api/admin/Vip/admin/purchase-nopayment',
    method: 'post',
    data
  })
}

// Admin gift hour to customer (limited 1 hour per week)
export function adminGiftHour(data) {
  return request({
    url: '/api/admin/Vip/admin/gift-hour',
    method: 'post',
    data
  })
}

// Get VIP audit logs
export function getVipAuditLogs(data) {
  return request({
    url: '/api/admin/Vip/audit/logs',
    method: 'post',
    data: data
  })
}


// Get VIP payment status by out trade number
export function getVipPayStatus(outTradeNo) {
  return request({
    url: `/api/admin/Vip/pay-status/${outTradeNo}`,
    method: 'get'
  })
}

// Get customer remaining VIP hours
export function getCustomerRemainingHours(customerId) {
  return request({
    url: `/api/admin/Vip/customer/${customerId}/remaining-hours`,
    method: 'get'
  })
}

// Package Type APIs
// Get VIP package types
export function getVipPackageTypes(params) {
  return request({
    url: '/api/admin/Vip/package-types',
    method: 'get',
    params
  })
}

// Create VIP package type
export function createVipPackageType(data) {
  return request({
    url: '/api/admin/Vip/package-types',
    method: 'post',
    data
  })
}

// Update VIP package type
export function updateVipPackageType(id, data) {
  return request({
    url: `/api/admin/Vip/package-types/${id}`,
    method: 'put',
    data
  })
}

// Delete VIP package type
export function deleteVipPackageType(id) {
  return request({
    url: `/api/admin/Vip/package-types/${id}`,
    method: 'delete'
  })
}

// Update customer VIP package
export function updateCustomerVip(id, data) {
  return request({
    url: `/api/admin/Vip/customer-vip/${id}`,
    method: 'put',
    data
  })
}

// Adjust customer VIP hours
export function adjustCustomerVipHours(id, data) {
  return request({
    url: `/api/admin/Vip/customer-vip/${id}/adjust-hours`,
    method: 'post',
    data
  })
}
